<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="5" class="pa-0">

          <v-card class="pa-3" color="transparent" flat max-width="600px">
            <v-card-title class="pa-3">
              <v-img :src="require(`@/assets/full_logo.png`)"/>
            </v-card-title>
            <v-form @submit="login">

              <v-card-text class="mt-3">
                <v-text-field
                    label="Email"
                    v-model="email"
                    color="success"
                    solo
                    prepend-icon="mdi-email"
                    :error-messages="api_errors['email']"
                    type="email"
                    autofocus
                />

                <v-text-field
                    label="Password"
                    v-model="password"
                    color="success"
                    solo
                    prepend-icon="mdi-lock-outline"
                    :error-messages="api_errors['password']"
                    :type="show_password ? 'text' : 'password'"
                >
                  <v-icon slot="append" color="primary" @click="show_password = !show_password">
                    {{ show_password ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </v-text-field>

              </v-card-text>

              <v-card-actions class="justify-center">
<!--                <v-btn class="px-10" color="success" type="submit">Let's Go</v-btn>-->
                <div class="">
                  <v-progress-circular :indeterminate="loading" size="72" color="success">
                    <v-btn fab x-large class="box-shadow" color="transparent" type="submit">
                      <v-icon size="48" color="white">mdi-fingerprint</v-icon>
                    </v-btn>
                  </v-progress-circular>
                  <p class="ma-0 text-center" style="color: white">Sign in</p>
                </div>
              </v-card-actions>
            </v-form>
          </v-card>


<!--          <div class="d-flex align-center">-->
<!--            <v-divider light/> <span class="mx-3" style="color: white"> or</span> <v-divider/>-->
<!--          </div>-->
<!--          <div class="d-flex justify-center">-->
<!--            <div class="google-btn" @click="getGoogleAuthUri">-->
<!--              <div class="google-icon-wrapper">-->
<!--                <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>-->
<!--              </div>-->
<!--              <p class="btn-text"><b>Sign in with google</b></p>-->
<!--            </div>-->
<!--          </div>-->
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapMutations} from "vuex";
export default {
  data: () => ({
    loading: false,
    email: '',
    password: '',
    show_password: false,
    api_errors: [],
  }),
  mounted () {
    this.clearStorage()
  },
  methods: {
    ...mapMutations({
      setAuthToken: 'SET_AUTH_TOKEN',
      setAuthUser: 'SET_AUTH_USER',
      clearStorage: 'CLEAR_STORAGE',
    }),
    login(e) {
      e.preventDefault()
      this.api_errors = []
      this.loading = true
      this.axios.post('api/login', {email: this.email, password: this.password})
          .then(({data}) => {
            this.setAuthToken(data.data.access_token)
            this.setAuthUser(data.data.user)
            this.$router.push('/')
          })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            // eslint-disable-next-line no-prototype-builtins
            if(this.api_errors.hasOwnProperty('unverified')) {
              sessionStorage.setItem('email', this.email)
              this.$router.push({name: 'Verify Email'})
            }
          })
          .then(() => {
            this.loading = false
          })
    },
    getGoogleAuthUri() {

    },
    fetchAuth() {

    },

  }
}
</script>

<style lang="scss">
.blob {
  background: black;
  border-radius: 50%;
  margin: 10px;
  height: 20px;
  width: 20px;
}


$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn {
  width: 184px;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $white;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    float: right;
    margin: 11px 11px 0 0;
    color: $white;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
    cursor: pointer;
  }
  &:active {
    background: $button-active-blue;
  }
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);
</style>